import React from 'react';
import { TableCell, TableRow, TableHead, TableSortLabel, Checkbox } from '@mui/material';
import { trackActivity } from '../../../utils/mixpanel';
import { PermissionWrapper } from '../../../wrappers';

const ReconcileInvoiceHD = ({ toggleBulkOps, item, createSortHandler, sortInfo, bulk }) => {

    const tableSorting = (key, name) => {
        const handleItemClicked = (page_type) => {
            trackActivity('Item Clicked', { page_title: `Reconcile Invoice Batch`, page_type: page_type, })
        }
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )
    }

    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['D'] }}>
                        <Checkbox
                            color='primary'
                            size='small'
                            onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)}
                            checked={item?.length === bulk?.ids?.length && item?.length > 0}
                        /> </PermissionWrapper>Action(s) </TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('name', 'Name')}</TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('start_date', 'Period')}</TableCell>
                <TableCell sx={{ minWidth: '100px' }}> {tableSorting('status', 'Status')}</TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('invoice_count', 'Invoice Count')}</TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('invoice_type', 'Invoice Type')}</TableCell>
                <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}> {tableSorting('currency', 'Currency')}</TableCell>
                <TableCell sx={{ minWidth: '160px', whiteSpace: 'nowrap' }}> {tableSorting('remarks', 'Remarks')}</TableCell>
            </TableRow>
        </TableHead>
    );
};

export default ReconcileInvoiceHD;